import { StaticBaseDao } from '@/dao';
import { Transaction, TIMMTransactionRequest, TransactionResponse } from '@/objects/generated';
import { useUserStore } from '@/stores';

export class TransactionDao extends StaticBaseDao {
    public static async GetTransactionsForDevice(deviceId: string | null): Promise<Transaction[]> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return [];
        }
        return this.BaseFetchArray(
            Transaction,
            `Transaction/GetTransactionsForDevice` + '?' + (deviceId == undefined ? '' : `deviceId=${deviceId}`),
            'GET',
        );
    }
    public static async AddTIMMTransaction(transaction: TIMMTransactionRequest, EventID: number): Promise<TransactionResponse | null> {
        return this.BaseFetch(
            TransactionResponse,
            `Transaction/AddTIMMTransaction` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            transaction,
        );
    }
    public static async GetTIMMTransactionsForStation(EventID: number, StationID: number): Promise<TIMMTransactionRequest[]> {
        return this.BaseFetchArray(
            TIMMTransactionRequest,
            `Transaction/GetTIMMTransactionsForStation` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (StationID == undefined ? '' : `StationID=${StationID}`),
            'GET',
        );
    }
}
